import api from "@/services/api";

export default {
  getList(params) {
    return api.get("/report/inventaris-asset", { params });
  },
  exportExcel(params) {
    return api.get("/report/inventaris-asset/export-excel", {
      params,
      responseType: "blob",
    });
  },
};
